// 顶部固定栏：全局搜索 + 通知铃铛 + 用户信息区（principal 显示 + 退出登录）
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Search, LogOut } from 'lucide-react';
import { loadSession } from '@/api/client';
import { logout } from '@/api/auth';

export default function Header() {
  const navigate = useNavigate();
  const session = loadSession();
  // 主体展示优先级：me.principal > session.principal > 兜底
  const principalName = session?.me?.principal || session?.principal || '代理商账号';
  const principalInitial = principalName.trim().slice(0, 2).toUpperCase() || 'AG';
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      // logout 内部已 clearSession + 触发 onAuthFailure → navigate('/login')
      await logout();
    } catch {
      // 兜底：logout 失败也已清会话，忽略
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center px-6 gap-4 shrink-0 shadow-sm">
      <div className="flex-1">
        <h1 className="text-slate-900 font-semibold text-base">代理商后台系统</h1>
      </div>
      <div className="flex items-center gap-2">
        {/* 搜索 */}
        <div className="relative">
          <Search className="w-4 h-4 text-slate-400 absolute left-2.5 top-1/2 -translate-y-1/2" />
          <input
            placeholder="搜索商户 / 价差记录 ..."
            className="bg-slate-50 border border-slate-200 rounded-lg pl-8 pr-3 py-1.5 text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:border-brand-400 focus:bg-white w-48 transition-colors"
            type="text"
          />
        </div>
        {/* 通知铃铛 */}
        <button
          type="button"
          onClick={() => navigate('/agent/settlement/notices')}
          className="relative p-2 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
          title="消息通知"
          aria-label="消息通知"
        >
          <Bell className="w-4.5 h-4.5" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full border border-white" />
        </button>
        {/* 分割线 */}
        <div className="h-6 w-px bg-slate-200" />
        {/* 用户信息区：principal 显示 + 退出登录 */}
        <div className="flex items-center gap-2 px-2 py-1">
          <div className="w-7 h-7 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0 border border-indigo-200">
            <span className="text-indigo-600 text-[10px] font-bold">{principalInitial}</span>
          </div>
          <div className="flex flex-col leading-tight min-w-0 max-w-[160px]">
            <span className="text-xs font-medium text-slate-800 truncate" title={principalName}>
              {principalName}
            </span>
            <span className="text-[10px] text-slate-400">代理商账号</span>
          </div>
          <button
            type="button"
            onClick={() => void handleLogout()}
            disabled={loggingOut}
            title="退出登录"
            className="ml-1 inline-flex items-center gap-1 rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-50 hover:text-red-600 hover:border-red-200 transition-colors disabled:opacity-60"
          >
            <LogOut className="w-3.5 h-3.5" />
            {loggingOut ? '退出中…' : '退出登录'}
          </button>
        </div>
      </div>
    </header>
  );
}
